export default __webpack_public_path__ + "static/media/keto_fats@2x.61b72b93.jpg";